//appends an array fo node objects to a parent node in order
let appendChildren = function ( parent, elements ) {
  elements.forEach( element => {
    parent.appendChild( element );
  })
}

let createInput = ( name, id, value, type, attributes ) => {
  let input = document.createElement('input');
  input.name = name;
  input.id = id;
  input.value = (value) ? value : '' ;
  input.type = type;
  if( attributes ){
    //placeholder
    input.placeholder = (attributes.placeholder) ? attributes.placeholder : '' ;
    //required
    input.required = (attributes.required) ? attributes.required : false ;
    //disabled
    input.disabled = (attributes.disabled) ? attributes.disabled : false ;
    //datalist
    if( attributes.datalist ){
      let datalist = createDatalist( attributes.datalist );
      input.setAttribute('list', attributes.datalist.id);
    }
    //checked
    if( attributes.checked && type == 'checkbox' ){
      input.checked = true;
    }
  }
  return input;
}

let createLabel = ( text, forId ) => {
  let label = document.createElement('label');
  label.setAttribute('for', forId);
  let labelText = document.createTextNode( text );
  label.appendChild( labelText );
  return label;
}

let createInputGroup = ( name, id, value, type, attributes, labelText ) => {
  let label = createLabel( labelText, id );
  let input = createInput( name, id, value, type, attributes );

  let inputGroup = document.createElement('div');
  if( type == 'checkbox' ){
    inputGroup.classList.add('checkbox-cont');
    appendChildren( inputGroup, [input, label] );
  } else {
    appendChildren( inputGroup, [label, input] );
  }

  return inputGroup;
}

let createDatalist = ( attributes ) => {
  let datalist = document.createElement('datalist');
  datalist.id = attributes.id;
  attributes.options.forEach( (option) => {
    let optionEl = document.createElement('option');
    optionEl.value = option.label;
    datalist.appendChild( optionEl );
  })
  document.body.appendChild( datalist );
  return datalist;
}

let createButton = ( text, type, classes ) => {
  let button = document.createElement('button');
  button.type = type;
  let buttonText = document.createTextNode( text );
  button.appendChild( buttonText );
  //classes
  if( classes.length ){
    classes.forEach( ( className ) => {
      button.classList.add( className );
    })
  }

  return button;
}



let elements = {
  appendChildren: appendChildren,
  create: {
    input: createInput,
    label: createLabel,
    inputGroup: createInputGroup,
    button: createButton,
    datalist: createDatalist
  }
}

export default elements;
